import React, { useEffect, useState } from "react";
import ContactBg from "../assests/contactBg.png";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
// Header import File
import ContactbannerImg from "../assests/contactBanner.jpg";
import prelorder from "../assests/loadingIcon.png";
import Logo from "../assests/mediLogo.png";
import { Link, NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import axios from "axios";
import { baseUrl } from "./Api/BaseUrl";
import { useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGooglePlusG,
  FaYoutube,
} from "react-icons/fa";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// Header import File

// Localization data
const headerTranslations = {
  1: {
    news: "News",
    agency: "Agency",
    services: "Services",
    work: "Work",
    team: "Team",
    contact: "Contact Us",
    ourteam: "Our Team",
    email: "Email",
    address: "Address",
    ourservices: "Our Services",
    quotes: "Ask for a Quotes",
    joinus: "Join Us",
    officelocation: "Office Location",
    sendmessage: "Send Message",
    callus: "Call Us Directly",
    jointeam: "Join Our Team",
    howcan: "HOW CAN HELP YOU?",
    lettogether: "Let's make something great work together.",
    inmind: "Got a Project in Mind?",
    gettouch: "Get in Touch with us",
    entername: "Enter Your Name*",
    enteremail: "Enter Email Address*",
    entermessage: "Enter Your Message",
    formtext:
      "We are committed to protecting your privacy. We will never collect information about you without your explicit consent.",
  },
  2: {
    news: "Nouvelles",
    agency: "Agence",
    services: "Services",
    work: "Travail",
    team: "Équipe",
    contact: "Contactez",
    ourteam: "Notre équipe",
    ourservices: "Nos prestations",
    email: "e-mail",
    address: "Adresse",
    quotes: "Demandez un devis",
    joinus: "Rejoignez-nous",
    officelocation: "Emplacement du bureau",
    sendmessage: "Envoyer un message",
    callus: "Appelez-nous directement",
    jointeam: "Rejoignez notre équipe",
    howcan: "COMMENT PEUT VOUS AIDER ?",
    lettogether: "Faisons quelque chose de grand ensemble.",
    inmind: "Vous avez un projet en tête ?",
    gettouch: "Contactez-nous",
    entername: "Entrez votre nom*",
    enteremail: "Entrez l'adresse e-mail*",
    entermessage: "Entrez votre message",
    formtext:
      "Nous nous engageons à protéger votre vie privée. Nous ne collecterons jamais d'informations vous concernant sans votre consentement explicite.",
  },
  3: {
    news: "الأخبار",
    agency: "وكالة",
    services: "الخدمات",
    work: "العمل",
    team: "الفريق",
    contact: "اتصل بنا",
    ourteam: "فريقنا",
    ourservices: "خدماتنا",
    email: "بريد إلكتروني",
    address: "عنوان",
    quotes: "اسأل عن الأسعار",
    joinus: "انضم إلينا",
    officelocation: "موقع المكتب",
    sendmessage: "أرسل رسالة",
    callus: "اتصل بنا مباشرة",
    jointeam: "انضم إلى فريقنا",
    howcan: "كيف يمكن أن تساعدك؟",
    lettogether: "دعونا نصنع شيئًا رائعًا بالعمل معًا.",
    inmind: "هل لديك مشروع في ذهنك؟",
    gettouch: "تواصل معنا",
    entername: "أدخل اسمك*",
    enteremail: "أدخل عنوان البريد الإلكتروني*",
    entermessage: "أدخل رسالتك",
    formtext:
      "نحن ملتزمون بحماية خصوصيتك. لن نقوم أبدًا بجمع معلومات عنك دون موافقتك الصريحة.",
  },
};

const ContactUs = () => {
  // ------- Header Import Code-------
  const [isOverflow, setIsOverflow] = useState(false);
  const [Active, setActive] = useState(false);
  const [contactData, setContactData] = useState(null);
  const [language, setLanguage] = useState(1);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [footerData, setFooterData] = useState(null);

  // Search toggle
  const toggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const searchQuery = e.target.elements.q.value;
    console.log("Search query:", searchQuery);
  };

  // ToogleControl Method
  const handleToggleClick = () => {
    if (Active) {
      setIsOverflow(!isOverflow);
      setActive(false);
      setTimeout(() => {
        document.querySelector(".all-cases").style.transitionDelay = "0.5s";
        document.querySelector(".all-cases .layer").style.transitionDelay =
          "0.3s";
        document.querySelector(".all-cases .inner").style.transitionDelay =
          "0s";
      }, 0);
    } else {
      setActive(true);
      setIsOverflow(!isOverflow);
      setTimeout(() => {
        document.querySelector(".all-cases.active").style.transitionDelay =
          "0s";
        document.querySelector(
          ".all-cases.active .layer"
        ).style.transitionDelay = "0.2s";
        document.querySelector(
          ".all-cases.active .inner"
        ).style.transitionDelay = "0.7s";
      }, 0);
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    comment: "",
  });

  useEffect(() => {
    const fetchContactDetails = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_cms_contact_us`, {
          language: language,
        });
        setContactData(response.data.details);
      } catch (error) {
        console.log("Error the Fetching data from Contact Us Details:", error);
      }
    };

    const fetchFooter = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_footer_section`, {
          language: language,
        });
        setFooterData(response.data.Details);
      } catch (error) {
        console.error("Error fetching the Footer Data:", error);
      }
    };
    fetchFooter();
    fetchContactDetails();
  }, [language]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Prepare the data to be sent
    const data = {
      name: formData.name,
      email: formData.email,
      message: formData.comment,
    };

    try {
      const response = await fetch(`${baseUrl}contact_us`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response.ok) {
        const responseData = await response.json();
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", comment: "" });
      } else {
        alert("Failed to send message. Please try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while sending the message.");
    }
  };

  const navigate = useNavigate();
  function handleButtonClick() {
    navigate("/quote");
  }

  function handleButtonClick2() {
    navigate("/join_inner");
  }

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      setLanguage(Number(savedLanguage));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const handleLanguage = (e) => {
    e.preventDefault();
    setLanguage(Number(e.target.value));
  };

  return (
    <>
      {/* Header & Banner Section Start */}
      <div>
        <div className="preloader">
          <div className="layer"></div>
          <div className="inner">
            <figure>
              <img src={prelorder} alt="Img" />
            </figure>
            <span>The Art of Contact and the Science of Data</span>
          </div>
        </div>

        <div className={`all-cases ${Active ? "active" : ""}`}>
          <div className="layer"> </div>
          <aside className="left-side left-side2">
            <div className="follow-us">FOLLOW US</div>
            <ul>
              <li>
                <Link to="#">
                  <i className="fab fa-facebook-f"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-twitter"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-google-plus-g"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-youtube"></i>
                </Link>
              </li>
            </ul>
            <div className="equalizer">
              <span></span> <span></span> <span></span> <span></span>
            </div>
          </aside>
          <div className="inner">
            <ul>
              <li>
                <NavLink
                  to="/news"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.news}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/agency"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.agency}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/services"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.services}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/work"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.work}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/team"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.team}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.contact}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <main>
          <div>
            <div className="main_header">
              <div
                className="completeMenu"
                style={{
                  background: "black",
                }}
              >
                <div className="logo">
                  <Link to="/">
                    <img src={Logo} alt="Img" />
                  </Link>
                </div>
                <div className="all-cases-link">
                  <span className="">
                    <div className="nav-open_main d-flex">
                      <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
                        <NavLink
                          to="/news"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.news}
                        </NavLink>
                        <NavLink
                          to="/agency"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.agency}
                        </NavLink>
                        <NavLink
                          to="/services"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.services}
                        </NavLink>
                        <NavLink
                          to="/work"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.work}
                        </NavLink>
                        <NavLink
                          to="/team"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.team}
                        </NavLink>
                        <NavLink
                          to="/contact"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.contact}
                        </NavLink>
                      </nav>
                      <div className="d-flex nav-open_main1">
                        <div className="language-switching">
                          <select value={language} onChange={handleLanguage}>
                            <option value={1}>ENG</option>
                            <option value={2}>FRE</option>
                            <option value={3}>عربي</option>
                          </select>
                        </div>
                        <div className="searching-toggle mx-0">
                          <div
                            className={`search-toggle ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                          >
                            <button
                              className="search-icon icon-search"
                              onClick={toggleSearch}
                            >
                              <i className="fa fa-fw fa-search"></i>
                            </button>
                            <button
                              className="search-icon icon-close"
                              onClick={toggleSearch}
                              style={{
                                display: isSearchOpen ? "inline-block" : "none",
                              }}
                            >
                              <i className="fa fa-fw fa-close"></i>
                            </button>
                          </div>

                          <div
                            className={`search-container d-flex ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                            style={{ display: isSearchOpen ? "block" : "none" }}
                          >
                            <form onSubmit={handleSearch}>
                              <input
                                type="text"
                                name="q"
                                id="search-terms"
                                placeholder="Search terms..."
                                autoFocus={isSearchOpen}
                              />
                              <button
                                type="submit"
                                name="submit"
                                value="Go"
                                className="search-icon"
                              >
                                <i className="fa fa-fw fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                  <b onClick={handleToggleClick}>
                    <i className={`fa ${Active ? "fa-solid" : "fa-bars"}`}></i>
                  </b>
                </div>
              </div>
            </div>
            <aside className="left-side">
              <div className="follow-us">FOLLOW US</div>
              <ul>
                <li>
                  <Link to="#">
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-google-plus-g"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-youtube"></i>
                  </Link>
                </li>
              </ul>
              <div className="equalizer">
                <span></span> <span></span> <span></span> <span></span>
              </div>
            </aside>
            <div
              className={`body-content ${isOverflow ? "overflow" : ""}`}
            ></div>
          </div>

          <header className="sliderImg">
            <div className="swiper-container gallery-top">
              <div className="BannerImg">
                <img src={ContactbannerImg} alt="BannerImage" />
              </div>
            </div>
            <div className="swiper-container gallery-thumbs">
              <Swiper
                spaceBetween={0}
                slidesPerView={3}
                autoplay={{
                  delay: 9900,
                  disableOnInteraction: false,
                }}
                freeMode
                watchSlidesProgress
                centeredSlides={true}
                touchRatio={0.2}
                slideToClickedSlide={true}
                loop={true}
                loopedSlides={3}
                modules={[Autoplay]}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 1,
                  },
                  640: {
                    slidesPerView: 1,
                  },
                  320: {
                    slidesPerView: 1,
                  },
                }}
                className="swiper-wrapper"
              >
                <SwiperSlide className="swiper-slide">
                  <p>{headerTranslations[language]?.contact}</p>
                </SwiperSlide>
              </Swiper>
            </div>
          </header>
        </main>
      </div>
      {/* Header & Banner Section End */}

      <section className="contactDown_section">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-md-6">
              <span className="text-uppercase d-inline-block text_headings mb-4 ml-sm-1">
                {headerTranslations[language]?.howcan}
              </span>
            </div>
            <div className="col-md-6 mb-4">
              <div className="d-flex justify-content-end  justify-content-sm-start ml-sm-1">
                <div>
                  <button className="contactButton" onClick={handleButtonClick}>
                    {headerTranslations[language]?.quotes}
                  </button>
                </div>
                <div className="ml-3">
                  <button
                    className="contactButton"
                    onClick={handleButtonClick2}
                  >
                    {headerTranslations[language]?.joinus}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-7 col-md-10">
              {contactData ? (
                <h3 className="mb-4 text-capitalize text_heading2">
                  {contactData.heading}
                </h3>
              ) : (
                <h3 className="mb-4 text-capitalize text_heading2">
                  Loading Api Data...
                </h3>
              )}
            </div>
            <div className="col-xl-6 col-lg-5 col-md-10">
              {contactData ? (
                <p
                  className="text_paragraph mt-4"
                  dangerouslySetInnerHTML={{
                    __html: contactData.description
                      .replace(/\r\n/g, "<br/>")
                      .replace(/\n/g, "<br/>"),
                  }}
                />
              ) : (
                <p className="text_paragraph mt-4">Loading Api Data...</p>
              )}
            </div>
          </div>
          <div className="row contactDown_textContent">
            <div className="col-md-3 text-start text-sm-start text_column">
              <span className="d-block textColumn_content">
                <i>
                  <PlaceOutlinedIcon />
                </i>
                {headerTranslations[language]?.officelocation}
              </span>
              <div className="last-paragraph-no-margin">
                {contactData ? (
                  <p
                    className="textColumn_data"
                    dangerouslySetInnerHTML={{
                      __html: contactData.office_location
                        .replace(/\r\n/g, "<br/>")
                        .replace(/\n/g, "<br/>"),
                    }}
                  />
                ) : (
                  <p className="textColumn_data">Loading Api Data...</p>
                )}
              </div>
            </div>

            <div className="col-md-3 text-start text-sm-start text_column">
              <span className="d-block textColumn_content">
                <i>
                  <EmailOutlinedIcon />
                </i>
                {headerTranslations[language]?.sendmessage}
              </span>
              <Link to="/cdn-cgi/l/email-protection#91f8fff7fed1e8fee4e3f5fefcf0f8ffbff2fefc">
                {contactData ? (
                  <p
                    className="__cf_email__ textColumn_data"
                    data-cfemail="d9b0b7bfb699a0b6acabbdb6b4b8b0b7f7bab6b4"
                    dangerouslySetInnerHTML={{
                      __html: contactData.send_message
                        .replace(/\r\n/g, "<br/>")
                        .replace(/\n/g, "<br/>"),
                    }}
                  />
                ) : (
                  <p>Loading Api Data...</p>
                )}
              </Link>
            </div>
            <div className="col-md-3 text-start text-sm-start text_column">
              <span className="d-block textColumn_content">
                <i>
                  <CallOutlinedIcon />
                </i>
                {headerTranslations[language]?.callus}
              </span>
              {contactData ? (
                <p>
                  <Link
                    to="tel:1800222000"
                    className="textColumn_data"
                    dangerouslySetInnerHTML={{
                      __html: contactData.call_us_directly
                        .replace(/\r\n/g, "<br/>")
                        .replace(/\n/g, "<br/>"),
                    }}
                  />
                </p>
              ) : (
                <p>Loading Api Data...</p>
              )}
            </div>
            <div className="col-md-3 text-start text-sm-start text_column">
              <span className="d-block textColumn_content">
                <i>
                  <PeopleOutlinedIcon />
                </i>
                {headerTranslations[language]?.jointeam}
              </span>
              <Link to="/cdn-cgi/l/email-protection#c2aaabb0a782bbadb7b0a6adafa3abaceca1adaf">
                {contactData ? (
                  <p
                    className="__cf_email__ textColumn_data mt-2"
                    data-cfemail="e8809aa891879d9a8c8785898186c68b8785"
                    dangerouslySetInnerHTML={{
                      __html: contactData.join_our_team
                        .replace(/\r\n/g, "<br/>")
                        .replace(/\n/g, "<br/>"),
                    }}
                  />
                ) : (
                  <p>Loading Api Data...</p>
                )}
              </Link>
            </div>
          </div>
          <div className="row justify-content-center lastText_content">
            <div className="col-auto text-center icon-with-text-style-08">
              <div className="feature-box feature-box-left-icon-middle overflow-hidden">
                <div className="feature-box-icon">
                  <i className="bi bi-chat-text icon-very-medium"></i>
                </div>
                <div className="feature-box-content text-uppercase">
                  {headerTranslations[language]?.lettogether}
                  <Link to="#" className="text-decoration-line-bottom-medium">
                    {headerTranslations[language]?.inmind}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact form Data */}
      <section className="contactForm_data">
        <div className="container-fluid overflow-hidden position-relative">
          <img
            className="position-absolute z-index-minus-1"
            src={ContactBg}
            alt="contactBackImg"
            style={{ display: "none", visibility: "hidden" }}
          />
          <div className="row justify-content-center mb-2">
            <div className="col-lg-6 text-center">
              <span className="text-uppercase text-base-color d-inline-block formText_content">
                {headerTranslations[language]?.gettouch}
              </span>
              <h3 className="text-dark-gray formText_heading">
                {headerTranslations[language]?.howcan}
              </h3>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-7 col-lg-11">
              <form onSubmit={handleSubmit} className="contact-form-style-03">
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <label className="form-label fw-600 mb-0">
                      {headerTranslations[language]?.entername}
                    </label>
                    <div className="position-relative form-group">
                      <span className="form-icon">
                        <i className="bi bi-emoji-smile"></i>
                      </span>
                      <input
                        className="border-radius-0px border-color-extra-medium-gray form-control required"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="What's your good name?"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-600 mb-0">
                      {headerTranslations[language]?.enteremail}
                    </label>
                    <div className="position-relative form-group mb-25px">
                      <span className="form-icon">
                        <i className="bi bi-envelope"></i>
                      </span>
                      <input
                        className="border-color-extra-medium-gray form-control required"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter your email address"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12 mb-4">
                    <label className="form-label fw-600 mb-0">
                      {headerTranslations[language]?.entermessage}
                    </label>
                    <div className="position-relative form-group form-textarea mb-0">
                      <textarea
                        className="form-control"
                        name="comment"
                        value={formData.comment}
                        onChange={handleChange}
                        placeholder="Describe about your project"
                        rows="4"
                        required
                      ></textarea>
                      <span className="form-icon">
                        <i className="bi bi-chat-square-dots"></i>
                      </span>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-lg-7 col-md-8">
                    <p className="formText_paragraph">
                      {headerTranslations[language]?.formtext}
                    </p>
                  </div>
                  <div className="col-xxl-6 col-lg-5 col-md-4 text-center text-md-end">
                    <button className="submitBtn submit" type="submit">
                      Send message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="logoFooter_content">
                <div className="footer_logo">
                  <img src={Logo} alt="footer logo" />
                </div>
                <div className="footer_content">
                  {footerData ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: footerData.description
                          .replace(/\r\n/g, "<br/>")
                          .replace(/\n/g, "<br/>"),
                      }}
                    />
                  ) : (
                    <p>Loading Api Data...</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="navigation-footer">
                <h4>{headerTranslations[language]?.ourservices}</h4>
                <ul>
                  <li>
                    <Link to="/news">{headerTranslations[language]?.news}</Link>
                  </li>
                  <li>
                    <Link to="/agency">
                      {headerTranslations[language]?.agency}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service">
                      {headerTranslations[language]?.services}
                    </Link>
                  </li>
                  <li>
                    <Link to="/work">{headerTranslations[language]?.work}</Link>
                  </li>
                  <li>
                    <Link to="/team">{headerTranslations[language]?.team}</Link>
                  </li>
                  <li>
                    <Link to="/contact"></Link>
                    {headerTranslations[language]?.contact}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footerContact_info">
                <h4>{headerTranslations[language]?.contact}</h4>
              </div>
              <div className="footerContact_data">
                <ul>
                  <li>{headerTranslations[language]?.contact}:- +9645689866</li>
                  <li>
                    {headerTranslations[language]?.email}:- info@medialgeria.com
                  </li>
                  <li>
                    {headerTranslations[language]?.address}:- 16122 Collins
                    Street, Melbourne, Australia
                  </li>
                </ul>
              </div>
              {/* <Link to="/contact" className="link">
                Get in touch
              </Link> */}
              <ul className="my-4 social">
                <li>
                  <Link
                    to="https://www.facebook.com/medialgeria/"
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaTwitter />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFLIm8hcMZygAAAAZG8qETwur3Uzvotg1uL5nQzzNIUTZR-X5fqW-nzhAu8LcBV1Tt4KamACgeaXdCmL3ypUUsKR0tNO1jdyL5JW5y05ftYOC8Mc2XWQdSaAlhRGzFdQTLhbEw=&original_referer=&sessionRedirect=https%3A%2F%2Ffr.linkedin.com%2Fcompany%2Fmedialgeria"
                    target="_blank"
                  >
                    <FaLinkedinIn />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaGooglePlusG />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.youtube.com/channel/UCDjQDI9xZ_qh2AW8ohoZRjw"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-12">
              <div className="footer-bar">
                <span className="copyright">
                  © 2024 Medialgeria | All Rights Reserved
                </span>
                <span className="creation">
                  Site created by
                  <Link to="https://www.webnmobappssolutions.com/">
                    webnmobapps solutions Pvt. Ltd
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ContactUs;
